import { ColDef, type ICellRendererParams } from "ag-grid-community";
import { Typography } from "@mui/material";
import { convertByteToSize } from "@/components/utils/helpers/convertByteToSize";

export const getResourceSizeColumnDef = (
  { propName, headerName } = {
    propName: "size",
    headerName: "Size",
  },
): ColDef => ({
  headerName,
  field: `resource.${propName}`,
  valueGetter: ({ data }) => convertByteToSize(data?.resource?.[propName]),
  comparator: (_, __, nodeA, nodeB) => {
    const dataA = nodeA?.data?.resource?.[propName];
    const dataB = nodeB?.data?.resource?.[propName];

    return dataA - dataB;
  },
  cellRenderer: ({ data }: ICellRendererParams) => {
    if (!data) {
      return null;
    }

    const size = data?.resource?.[propName] ?? 0;

    return <Typography variant="body2">{convertByteToSize(size)}</Typography>;
  },
});
